<template>
  <div class="forgetPassword">
    <div v-if="this.$lang.currentLang=='zh_CN'">
      <div class="top">
        <div class="left">
          <!-- <div class="logoName">{{$t('retrieve.Retrieve_password')}}</div> -->
          <div class="logoName" 
          v-for="(item,index) in passwordMethod" 
          :key="item.name"
          @click="tabPassword(index)"
          :class="{activet:!(index-passwordTab)}"
          style="opacity:0.5;color:#000;padding-right:15px;"
          >
            {{item.name}}
          </div>

        </div>
        <div class="right">
          <i class="el-icon-close" style="font-size: 24px;" @click="$emit('changeMode','login')"></i>
          <!-- <span class="rightname" @click="$emit('changeMode','signup')">{{$t('retrieve.signup')}}</span>
          <span class="icons">/</span>
          <span class="rightname" @click="$emit('changeMode','login')">{{$t('retrieve.login')}}</span> -->
        </div>
      </div>
      <div>
        <el-steps :active="currentStep" align-center finish-status="finish" class="elsteps">
          <el-step :title="$t('retrieve.step1')" :description="$t('retrieve.Enter_account')">
            <i style="font-size:30px;" v-if="currentStep!=0" class="el-icon-success" slot="icon">
            </i>
          </el-step>
          <el-step :title="$t('retrieve.step2')" :description="$t('retrieve.Verify_identidy')">
            <i style="font-size:30px;" v-if="currentStep >1" class="el-icon-success" slot="icon">
              </i>
          </el-step>
          <el-step :title="$t('retrieve.step3')" :description="$t('retrieve.reset_Password')">
            <i style="font-size:30px;" v-if="currentStep >2" class="el-icon-success" slot="icon">
              </i>
          </el-step>
          <el-step :title="$t('retrieve.step4')" :description="$t('retrieve.finish')">
            <i style="font-size:30px;" v-if="currentStep >3" class="el-icon-success" slot="icon">
              </i>
          </el-step>
        </el-steps>
      </div>
      <div v-if="this.hidePassword==0">
        <div class="useinforform" v-if="currentStep==0">
          <el-form :model="loginForm" ref="loginForm" class="usercode" :rules="loginRules">
            <el-form-item prop="usename">
              <el-input
                class="inputusename"
                v-model ="loginForm.usename"
                :placeholder="$t('retrieve.enter_name')"
                clearable
              >
                <img
                  slot="prefix"
                  src="@/assets/img/usr.png"
                  style="width:18px;height:22px;margin-top: 10px;margin-left: 20px;"
                />
              </el-input>
            </el-form-item>
            <el-form-item prop="verifycode">
              <div class="yanzhenginfor">
                <el-input
                  v-model="loginForm.verifycode"
                  :placeholder="$t('retrieve.enter_code')"
                  class="inputpictures"
                >
                  <img
                    slot="prefix"
                    src="@/assets/img/yanzhengma.png"
                    style="width:18px;height:22px;margin-top: 10px;margin-left: 20px;"
                  />
                </el-input>
                <div @click="refreshCode" class="huanyizhang">
                  <s-identify :identifyCode="identifyCode" :contentWidth="134" :contentHeight="45"></s-identify>
                </div>
              </div>
            </el-form-item>
          </el-form>
          <div class="error-hollow">
            <span class="error">{{errorMsg}}</span>
          </div>
          <button class="button button-solid" type="primary" @click="handleLogin">{{$t('retrieve.confirm')}}</button>
        </div>
        <div class="useinforforms" v-if="currentStep==1">
          <!-- 手机号验证表单 -->
          <el-form :model="mobileForm" ref="mobileForm" :rules="useRules">
            <el-form-item prop="mobile">
              <el-input
                class="inputusename"
                :placeholder="$t('retrieve.bound_mobile')"
                v-model.trim="mobileForm.mobile"
                clearable
              >
                <img
                  slot="prefix"
                  src="@/assets/img/shouji.png"
                  style="width:13px;height:22px;margin-top: 10px;margin-left: 20px;"
                />
              </el-input>
            </el-form-item>
            <el-form-item prop="smsCode">
              <el-input
                class="inputpicture"
                :placeholder="$t('retrieve.enter_code')"
                v-model.trim="mobileForm.smsCode"
                clearable
              >
                <img
                  slot="prefix"
                  src="@/assets/img/yanzhengma.png"
                  style="width:18px;height:22px;margin-top: 10px;margin-left: 20px;"
                />
              </el-input>
              <el-button
                class="getcode"
                v-if="show"
                v-loading="isLoading"
                v-on:click="getSmsCode"
              >{{$t('retrieve.Obtain_code')}}</el-button>
              <el-button class="getcode" v-if="!show">{{count}} s</el-button>
            </el-form-item>
          </el-form>
          <div class="hidecode">
            <div class="one" v-if="!show">
              <span class="two">
                <i class="iconfont icon-ok"></i>
              </span>
              <span class="receivecode" v-if="!show">{{$t('retrieve.code_1minute')}}</span>
            </div>
          </div>
          <div class="error-hollow">
            <span class="error">{{errorMsg}}</span>
          </div>
          <button class="button button-solid" type="primary" @click="confing1">{{$t('retrieve.confirm')}}</button>
        </div>
        <div class="useinforformss" v-if="currentStep==2">
          <el-form :model="formpwd" ref="formpwd" :rules="resetRules">
            <el-form-item prop="pwd">
              <el-input
                type="text"
                class="password"
                :placeholder="$t('retrieve.Newloginpassword')"
                v-model.trim="formpwd.pwd"
                clearable
              >
                <img
                  slot="prefix"
                  src="@/assets/img/mima.png"
                  style="width:18px;height:22px;margin-top: 10px;margin-left: 20px;"
                />
              </el-input>
            </el-form-item>
            <el-form-item prop="confPwd">
              <el-input
                type="text"
                class="password"
                :placeholder="$t('retrieve.Confirmloginpassword')"
                v-model.trim="formpwd.confPwd"
                clearable
              >
                <img
                  slot="prefix"
                  src="@/assets/img/mima.png"
                  style="width:18px;height:22px;margin-top: 10px;margin-left: 20px;"
                />
              </el-input>
            </el-form-item>
          </el-form>
          <div class="error-hollow">
            <span class="error">{{errorMsg}}</span>
          </div>
          <button class="buttons button-solid" type="primary" @click="confing2">{{$t('retrieve.confirm')}}</button>
        </div>
      </div>
      <!-- 邮箱验证 -->
      <div v-else>
        <div class="useinforform" v-if="currentStep==0">
          <el-form :model="loginForm" ref="loginForm" class="usercode" :rules="loginRules">
            <el-form-item prop="usename">
              <el-input
                class="inputusename"
                v-model ="loginForm.usename"
                :placeholder="$t('retrieve.enter_name')"
                clearable
              >
                <img
                  slot="prefix"
                  src="@/assets/img/usr.png"
                  style="width:18px;height:22px;margin-top: 10px;margin-left: 20px;"
                />
              </el-input>
            </el-form-item>
            <el-form-item prop="verifycode">
              <div class="yanzhenginfor">
                <el-input
                  v-model="loginForm.verifycode"
                  :placeholder="$t('retrieve.enter_code')"
                  class="inputpictures"
                >
                  <img
                    slot="prefix"
                    src="@/assets/img/yanzhengma.png"
                    style="width:18px;height:22px;margin-top: 10px;margin-left: 20px;"
                  />
                </el-input>
                <div @click="refreshCode" class="huanyizhang">
                  <s-identify :identifyCode="identifyCode" :contentWidth="134" :contentHeight="45"></s-identify>
                </div>
              </div>
            </el-form-item>
          </el-form>
          <div class="error-hollow">
            <span class="error">{{errorMsg}}</span>
          </div>
          <button class="button button-solid" type="primary" @click="handleLogin1">{{$t('retrieve.confirm')}}</button>
        </div>
        <div class="useinforforms" v-if="currentStep==1">
          <el-form :model="emailForm" ref="emailForm" :rules="emailRules">
            <el-form-item prop="email">
              <el-input
                class="inputusename"
                :placeholder="$t('retrieve.bound_email')"
                v-model.trim="emailForm.email"
                clearable
              >
                <img
                  slot="prefix"
                  src="@/assets/img/youxiang.png"
                  style="width:19px;height:14px;margin-top: 15px;margin-left: 20px;"
                />
              </el-input>
            </el-form-item>
            <el-form-item prop="smsCode">
              <el-input
                class="inputpicture"
                :placeholder="$t('retrieve.enter_code')"
                v-model.trim="emailForm.smsCode"
                clearable
              >
                <img
                  slot="prefix"
                  src="@/assets/img/yanzhengma.png"
                  style="width:18px;height:22px;margin-top: 10px;margin-left: 20px;"
                />
              </el-input>
              <el-button
                class="getcode"
                v-if="show"
                v-loading="isLoading"
                v-on:click="emailSmsCode"
              >{{$t('retrieve.Obtain_code')}}</el-button>
              <el-button class="getcode" v-if="!show">{{count}} s</el-button>
            </el-form-item>
          </el-form>
          <div class="hidecode">
            <div class="one" v-if="!show">
              <span class="two">
                <i class="iconfont icon-ok"></i>
              </span>
              <span class="receivecode" v-if="!show">{{$t('retrieve.code_5minutes')}}</span>
            </div>
          </div>
          <div class="error-hollow">
            <span class="error">{{errorMsg}}</span>
          </div>
          <button class="button button-solid" type="primary" @click="emailConfing">{{$t('retrieve.confirm')}}</button>
        </div>
        <div class="useinforformss" v-if="currentStep==2">
          <el-form :model="formpwd" ref="formpwd" :rules="resetRules">
            <el-form-item prop="pwd">
              <el-input
                type="text"
                class="password"
                :placeholder="$t('retrieve.Newloginpassword')"
                v-model.trim="formpwd.pwd"
                clearable
              >
                <img
                  slot="prefix"
                  src="@/assets/img/mima.png"
                  style="width:18px;height:22px;margin-top: 10px;margin-left: 20px;"
                />
              </el-input>
            </el-form-item>
            <el-form-item prop="confPwd">
              <el-input
                type="text"
                class="password"
                :placeholder="$t('retrieve.Confirmloginpassword')"
                v-model.trim="formpwd.confPwd"
                clearable
              >
                <img
                  slot="prefix"
                  src="@/assets/img/mima.png"
                  style="width:18px;height:22px;margin-top: 10px;margin-left: 20px;"
                />
              </el-input>
            </el-form-item>
          </el-form>
          <div class="error-hollow">
            <span class="error">{{errorMsg}}</span>
          </div>
          <button class="buttons button-solid" type="primary" @click="emailConfing2">{{$t('retrieve.confirm')}}</button>
        </div>
      </div>

      <div class="re-register" v-if="currentStep==3">
        <div class="prompt-container">
          <span class="icon-container">
            <i class="iconfont icon-ok"></i>
          </span>
        </div>
        <div style="margin-top:-55px">
          <span class="acounttop">{{$t('retrieve.Reset_successfully')}}</span>
          <div style="margin-top:14px;"></div>
          <span class="rightname" @click="$emit('changeMode','login')">{{$t('retrieve.re-register')}}</span>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="top">
        <div class="left">
          <div class="logoName">{{$t('retrieve.Retrieve_passwordEmail')}}</div>
        </div>
        <div class="right">
          <i class="el-icon-close" style="font-size: 24px;" @click="$emit('changeMode','login')"></i>
          <!-- <span class="rightname" @click="$emit('changeMode','signup')">{{$t('retrieve.signup')}}</span>
          <span class="icons">/</span>
          <span class="rightname" @click="$emit('changeMode','login')">{{$t('retrieve.login')}}</span> -->
        </div>
      </div>
      <div>
        <el-steps :active="currentStep" align-center finish-status="finish" class="elsteps">
          <el-step :title="$t('retrieve.step1')" :description="$t('retrieve.Enter_account')">
            <i style="font-size:30px;" v-if="currentStep!=0" class="el-icon-success" slot="icon">
            </i>
          </el-step>
          <el-step :title="$t('retrieve.step2')" :description="$t('retrieve.Verify_identidy')">
            <i style="font-size:30px;" v-if="currentStep >1" class="el-icon-success" slot="icon">
              </i>
          </el-step>
          <el-step :title="$t('retrieve.step3')" :description="$t('retrieve.reset_Password')">
            <i style="font-size:30px;" v-if="currentStep >2" class="el-icon-success" slot="icon">
              </i>
          </el-step>
          <el-step :title="$t('retrieve.step4')" :description="$t('retrieve.finish')">
            <i style="font-size:30px;" v-if="currentStep >3" class="el-icon-success" slot="icon">
              </i>
          </el-step>
        </el-steps>
      </div>
      <!-- 邮箱验证 -->
      <div>
        <div class="useinforform" v-if="currentStep==0">
          <el-form :model="loginForm" ref="loginForm" class="usercode" :rules="loginRules">
            <el-form-item prop="usename">
              <el-input
                class="inputusename"
                v-model ="loginForm.usename"
                :placeholder="$t('retrieve.enter_name')"
                clearable
              >
                <img
                  slot="prefix"
                  src="@/assets/img/usr.png"
                  style="width:18px;height:22px;margin-top: 10px;margin-left: 20px;"
                />
              </el-input>
            </el-form-item>
            <el-form-item prop="verifycode">
              <div class="yanzhenginfor">
                <el-input
                  v-model="loginForm.verifycode"
                  :placeholder="$t('retrieve.enter_code')"
                  class="inputpictures"
                >
                  <img
                    slot="prefix"
                    src="@/assets/img/yanzhengma.png"
                    style="width:18px;height:22px;margin-top: 10px;margin-left: 20px;"
                  />
                </el-input>
                <div @click="refreshCode" class="huanyizhang">
                  <s-identify :identifyCode="identifyCode" :contentWidth="134" :contentHeight="45"></s-identify>
                </div>
              </div>
            </el-form-item>
          </el-form>
          <div class="error-hollow">
            <span class="error">{{errorMsg}}</span>
          </div>
          <button class="button button-solid" type="primary" @click="handleLogin1">{{$t('retrieve.confirm')}}</button>
        </div>
        <div class="useinforforms" v-if="currentStep==1">
          <el-form :model="emailForm" ref="emailForm" :rules="emailRules">
            <el-form-item prop="email">
              <el-input
                class="inputusename"
                :placeholder="$t('retrieve.bound_email')"
                v-model.trim="emailForm.email"
                clearable
              >
                <img
                  slot="prefix"
                  src="@/assets/img/youxiang.png"
                  style="width:19px;height:14px;margin-top: 15px;margin-left: 20px;"
                />
              </el-input>
            </el-form-item>
            <el-form-item prop="smsCode">
              <el-input
                class="inputpicture"
                :placeholder="$t('retrieve.enter_code')"
                v-model.trim="emailForm.smsCode"
                clearable
              >
                <img
                  slot="prefix"
                  src="@/assets/img/yanzhengma.png"
                  style="width:18px;height:22px;margin-top: 10px;margin-left: 20px;"
                />
              </el-input>
              <el-button
                class="getcode"
                v-if="show"
                v-loading="isLoading"
                v-on:click="emailSmsCode"
              >{{$t('retrieve.Obtain_code')}}</el-button>
              <el-button class="getcode" v-if="!show">{{count}} s</el-button>
            </el-form-item>
          </el-form>
          <div class="hidecode">
            <div class="one" v-if="!show">
              <span class="two">
                <i class="iconfont icon-ok"></i>
              </span>
              <span class="receivecode" v-if="!show">{{$t('retrieve.code_5minutes')}}</span>
            </div>
          </div>
          <div class="error-hollow">
            <span class="error">{{errorMsg}}</span>
          </div>
          <button class="button button-solid" type="primary" @click="emailConfing">{{$t('retrieve.confirm')}}</button>
        </div>
        <div class="useinforformss" v-if="currentStep==2">
          <el-form :model="formpwd" ref="formpwd" :rules="resetRules">
            <el-form-item prop="pwd">
              <el-input
                type="text"
                class="password"
                :placeholder="$t('retrieve.Newloginpassword')"
                v-model.trim="formpwd.pwd"
                clearable
              >
                <img
                  slot="prefix"
                  src="@/assets/img/mima.png"
                  style="width:18px;height:22px;margin-top: 10px;margin-left: 20px;"
                />
              </el-input>
            </el-form-item>
            <el-form-item prop="confPwd">
              <el-input
                type="text"
                class="password"
                :placeholder="$t('retrieve.Confirmloginpassword')"
                v-model.trim="formpwd.confPwd"
                clearable
              >
                <img
                  slot="prefix"
                  src="@/assets/img/mima.png"
                  style="width:18px;height:22px;margin-top: 10px;margin-left: 20px;"
                />
              </el-input>
            </el-form-item>
          </el-form>
          <div class="error-hollow">
            <span class="error">{{errorMsg}}</span>
          </div>
          <button class="buttons button-solid" type="primary" @click="emailConfing2">{{$t('retrieve.confirm')}}</button>
        </div>
      </div>

      <div class="re-register" v-if="currentStep==3">
        <div class="prompt-container">
          <span class="icon-container">
            <i class="iconfont icon-ok"></i>
          </span>
        </div>
        <div style="margin-top:-55px">
          <span class="acounttop">{{$t('retrieve.Reset_successfully')}}</span>
          <div style="margin-top:14px;"></div>
          <span class="rightname" @click="$emit('changeMode','login')">{{$t('retrieve.re-register')}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SIdentify from "@/components/identify/identify.vue";
export default {
  data() {
    // 验证码自定义验证规则
    const validateVerifycode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("retrieve.enter_code")));
      } else if (value.toLowerCase() !== this.identifyCode.toLowerCase()) {
        // this.refreshCode()
        callback(new Error(this.$t("retrieve.Incorrect_code")));
      } else {
        callback();
      }
    };
    return {
      
      //找回密码方式
      passwordTab:0,
      hidePassword:0,
      passwordMethod:[
        {
          name:this.$t("retrieve.Retrieve_passwordPhone"),
          val:0,
        },
        {
          name:this.$t("retrieve.Retrieve_passwordEmail"),
          val:1,
        },
      ],
      isLoading: false,
      errorMsg: "", // 错误信息
      two: true,
      show: true,
      timer: null,
      count: "",
      currentStep: 0,
      chars: [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z"
      ],
      fontstyle: {},
      loginForm: {
        usename: "",
        verifycode: ""
      },
      mobileForm: {
        mobile: "",
        smsCode: ""
      },
      emailForm: {
        email: "",
        smsCode: ""
      },
      formpwd: {
        pwd: "",
        confPwd: ""
      },
      checked: false,
      identifyCodes: [],
      identifyCode: "",
      // 绑定在form表单中的验证规则
      loginRules: {
        verifycode: [
          { required: true, trigger: "blur", validator: validateVerifycode }
        ],
        usename: [
          {
            required: true,
            message: this.$t("retrieve.enter_name"),
            trigger: "blur"
          },
          {
            min: 2,
            max: 32,
            message: this.$t("login.usrformat"),
            trigger: "blur"
          }
        ]
      },
      useRules: {
        mobile: [
          {
            required: true,
            message: this.$t("message.mobile_is_required"),
            trigger: "blur"
          },
          {
            min: 6,
            max: 32,
            // pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
            message: this.$t("signup.mobileformat"),
            trigger: "blur"
          }
        ],
        smsCode: [
          {
            required: true,
            message: this.$t("retrieve.enter_code"),
            trigger: "blur"
          }
        ]
      },
      emailRules: {
        email: [
          {
            required: true,
            message: this.$t("message.email_is_required"),
            trigger: "blur"
          },
          {
            pattern: /^[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)?@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: this.$t("message.email_info"),
            trigger: "blur"
          }
        ],
        smsCode: [
          {
            required: true,
            message: this.$t("retrieve.enter_code"),
            trigger: "blur"
          }
        ]
      },
      resetRules: {
        // 密码
        pwd: [
          {
            required: true,
            message: this.$t("message.pwd_is_required"),
            trigger: "blur"
          },
          {
            pattern: /^[\w]{6,32}$/, //数字字母下划线
            message: this.$t("signup.pwdformat"),
            trigger: "blur"
          }
        ],
        // 确认密码
        confPwd: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error(this.$t("message.pwdAgain")));
              } else if (value !== this.formpwd.pwd) {
                callback(new Error(this.$t("message.pwdNotsame")));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ]
      }
    };
  },
  components: {
    SIdentify
  },
  created() {},
  mounted() {
    // 验证码初始化
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
  },
  watch:{
    currentStep(val) {
      if(val == 0){
        this.refreshCode()
      }
    },
  },
  computed: {},
  props: [],
  methods: {
    //切换密码找回方式
    tabPassword(index){
      this.errorMsg=""
      this.loginForm.usename=""
      this.loginForm.verifycode=""
      this.mobileForm.mobile=""
      this.mobileForm.smsCode=""
      this.emailForm.email=""
      this.emailForm.smsCode=""
      this.formpwd.pwd=""
      this.formpwd.confPwd=""
      this.currentStep = 0
      if(this.$refs.loginForm)
      this.$refs.loginForm.resetFields();
      if(this.$refs.mobileForm)
      this.$refs.mobileForm.resetFields();
      if(this.$refs.emailForm)
      this.$refs.emailForm.resetFields();
      if(this.$refs.formpwd)
      this.$refs.formpwd.resetFields();
      this.show = true;
      clearInterval(this.timer);
      this.timer = null;
      if (index==1) {
        this.passwordTab = index
        this.hidePassword=index
      }else{
        this.passwordTab = index
        this.hidePassword=0
      }
    },
    // 邮箱获取验证码
    emailSmsCode() {
      if (!this.emailForm.email) {
        this.errorMsg = this.$t("retrieve.email_first");
        // this.$message.error(this.$t("retrieve.email_first"));
      } else {
        let param = {
          usr: this.loginForm.usename,
          email: this.emailForm.email,
          msgType: 2,
          channel: 1,
          source: 1,
          i18n: this.$lang.currentLang,
          webName: "DessMonitor",
          emsCode: this.$lang.currentLang == "zh_CN" ? "DessmonitorFindpw" : "DessmonitorFindpwEN",
        };
        this.isLoading = true
        // this.$message.success(this.$t("retrieve.Getting_progress"));
        this.$request.get1("sendSmsCode", param).then(res => {
          if (res.err == 0) {
            this.errorMsg = "";
            // this.$message.success(this.$t("retrieve.Get_codeSucc"));
            const TIME_COUNT = 300;
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.show = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.show = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          }else if(res.err == 515) {
              setTimeout(() => {
               this.errorMsg = this.$t("retrieve.passwordEmail1");
               },500)
          }else if(res.err == 514) {
              setTimeout(() => {
               this.errorMsg = this.$t("retrieve.passwordEmail");
               },500)
          } else {
            this.errorMsg = this.$t(`errCode.${res.err}`);
            // this.$message.error(this.$t(`errCode.${res.err}`));
          }
          this.isLoading = false
        });
      }
    },
    // 手机号获取验证码
    getSmsCode() {
      if (!this.mobileForm.mobile) {
        this.errorMsg = this.$t("retrieve.mobile_first");
        // this.$message.error(this.$t("retrieve.mobile_first"));
      } else {
        let param = {
          usr: this.loginForm.usename,
          mobile: this.mobileForm.mobile,
          msgType: "02",
          channel: "00",
          source: 1,
          i18n: this.$lang.currentLang,
          webName: "DessMonitor"
        };
        this.isLoading = true
        // this.$message.success(this.$t("retrieve.Getting_progress"));
        this.$request.get1("sendSmsCode", param).then(res => {
          if (res.err == 0) {
            this.errorMsg = "";
            // this.$message.success(this.$t("retrieve.Get_codeSucc"));
            const TIME_COUNT = 60;
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.show = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.show = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          }else if(res.err == 515) {
              setTimeout(() => {
               this.errorMsg = this.$t("retrieve.passwordPhone1");
               },500)
          }else if(res.err == 514) {
              setTimeout(() => {
               this.errorMsg = this.$t("retrieve.passwordPhone");
               },500)
          }else {
            setTimeout(() => {
              this.errorMsg = this.$t(`errCode.${res.err}`);
              // this.$message.error(this.$t(`errCode.${res.err}`));
            }, 1000);
          }
            this.isLoading = false

        });
      }
    },
    // 手机点击登入按钮
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
      if (!valid) return false;
        {
          let param = {
            usr: this.loginForm.usename,
            msgType: "02",
            channel: 0,
         };
      this.$request.get1("sendSmsCode", param).then(res => {
        // if (res.err == 261) {
        //   setTimeout(() => {
        //     this.errorMsg = this.$t(`errCode.${res.err}`);
        //     },1000)
        //     }else if(res.err == 514) {
        //      setTimeout(() => {
        //        this.errorMsg = this.$t(`errCode.${res.err}`);
        //      },1000)
        //     } else 
            if(res.err == 515) {
              this.errorMsg = "";
             this.currentStep++;
            }else if(res.err == 514) {
              setTimeout(() => {
               this.errorMsg = this.$t("retrieve.passwordPhone");
               this.refreshCode()
               },500)
            }else{
             setTimeout(() => {
               this.errorMsg = this.$t(`errCode.${res.err}`);
               this.refreshCode()
               },500)
            }
          });
        }
      })
    },
    // 邮箱点击登入按钮
    handleLogin1() {
      this.$refs.loginForm.validate(valid => {
      if (!valid) return false;
        {
          let param = {
            usr: this.loginForm.usename,
            msgType: "02",
            channel: 1,
         };
      this.$request.get1("sendSmsCode", param).then(res => {
        // if (res.err == 261) {
        //   setTimeout(() => {
        //     this.errorMsg = this.$t(`errCode.${res.err}`);
        //     },1000)
        //     }else if(res.err == 514) {
        //      setTimeout(() => {
        //        this.errorMsg = this.$t(`errCode.${res.err}`);
        //      },1000)
        //     } else 
            if(res.err == 515) {
              this.errorMsg = "";
             this.currentStep++;
            }else if(res.err == 514) {
              setTimeout(() => {
               this.errorMsg = this.$t("retrieve.passwordEmail");
               this.refreshCode()
               },500)
            }else{
             setTimeout(() => {
               this.errorMsg = this.$t(`errCode.${res.err}`);
               this.refreshCode()
               },500)
            }
          });
        }
      })
    },
    // 生成随机数
    randomNum() {
      var idx = Math.ceil(Math.random() * 35);
      return this.chars[idx];
    },
    // 切换验证码
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    // 生成四位随机验证码
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.randomNum();
      }
    },
    // 手机号表单提交
    confing1() {
      this.$refs.mobileForm.validate(valid => {
        if (!valid) return false;
        {
          let param = {
            usr: this.loginForm.usename,
            msgType: "02",
            smsCode: this.mobileForm.smsCode
          };
          this.$request.get1("confirmSmsCode", param).then(res => {
            if (res.err == 0) {
              this.errorMsg = "";
              this.currentStep++;
            }else if(res.err == 515) {
              setTimeout(() => {
               this.errorMsg = this.$t("retrieve.passwordPhone1");
               },500)
            } else {
              setTimeout(() => {
                // this.$message.error(this.$t(`errCode.${res.err}`));
                this.errorMsg = this.$t(`errCode.${res.err}`);
              }, 1000);
            }
          });
        }
      });
    },
    // 邮箱表单提交
    emailConfing() {
      this.$refs.emailForm.validate(valid => {
        if (!valid) return false;
        {
          let param = {
            usr: this.loginForm.usename,
            msgType: "02",
            smsCode: this.emailForm.smsCode
          };
          this.$request.get1("confirmSmsCode", param).then(res => {
            if (res.err == 0) {
              this.errorMsg = "";
              this.currentStep++;
            }else if(res.err == 515) {
              setTimeout(() => {
               this.errorMsg = this.$t("retrieve.passwordEmail1");
               },500)
            } else {
              setTimeout(() => {
                // this.$message.error(this.$t(`errCode.${res.err}`));
                this.errorMsg = this.$t(`errCode.${res.err}`);
              }, 1000);
            }
          });
        }
      });
    },
    // 手机号新密码的表单提交
    confing2() {
      this.$refs.formpwd.validate(valid => {
        if (!valid) return false;
        {
          let param = {
            usr: this.loginForm.usename,
            mobile: this.mobileForm.mobile,
            msgType: "02",
            channel: "00",
            smsCode: this.mobileForm.smsCode,
            pwd: this.formpwd.pwd
          };
          this.$request.changePwds(param).then(res => {
            if (res.err == 0) {
              // this.$message.success(this.$t("retrieve.Reset_passwordSuc"));
              this.errorMsg = this.$t("retrieve.Reset_passwordSuc");
              this.currentStep++;
            } else {
              // this.$message.error(this.$t(`errCode.${res.err}`));
              this.errorMsg = this.$t(`errCode.${res.err}`);
            }
          });
        }
      });
    },
    // 邮箱新密码的表单提交
    emailConfing2() {
      this.$refs.formpwd.validate(valid => {
        if (!valid) return false;
        {
          let param = {
            usr: this.loginForm.usename,
            email: this.emailForm.email,
            msgType: "02",
            channel: "01",
            smsCode: this.emailForm.smsCode,
            pwd: this.formpwd.pwd
          };
          this.$request.changesPwd(param).then(res => {
            if (res.err == 0) {
              // this.$message.success(this.$t("retrieve.Reset_passwordSuc"));
              this.errorMsg = this.$t("retrieve.Reset_passwordSuc");
              this.currentStep++;
            } else {
              // this.$message.error(this.$t(`errCode.${res.err}`));
              this.errorMsg = this.$t(`errCode.${res.err}`);
            }
          });
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../../assets/css/mixin.less");
.forgetPassword {
  width: 1054px;
  height: 542px;
  margin-top: 200px;
  background: rgba(255, 255, 255, 0.8);
  box-shadow: 0px 18px 57px 0px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  /deep/.el-input--suffix .el-input__inner {
    height: 45px;
    padding-left: 47px;
  }
  /deep/.el-input__inner {
    height: 45px;
    padding-left: 47px;
  }
  /deep/.el-input--prefix .el-input__inner {
    height: 45px;
    padding-left: 47px;
  }
  .elsteps {
    width: 770px;
    height: 140px;
    margin: 30px auto;
  }

  .top {
    height: 78px;
    width: 970px;
    // background: #f2f2f2;
    display: flex;
    margin-left: 40px;
    justify-content: space-between;
    border-bottom: 1px solid #b1cfee;
    align-items: center;
    .left {
      display: flex;
      align-items: center;
      // margin-left: 39px;
      .logoName {
        font-size: 24px;
      }
      .activet{
        display: inline-block;
        border-radius: 5px;
        padding: 5px;
        opacity: 0.9 !important;
      }
    }
    .right {
      // width: 140px;
      height: 32px;
      cursor: pointer;
      // border: 1px solid rgb(21, 122, 232);
      border-radius: 5px;
      // margin-right: 40px;
      text-align: center;
      font-size: 16px;
      font-weight: 300;
      color: rgb(3, 103, 204);
      line-height: 32px;
      // .rightname {
      //   cursor: pointer;
      //   margin: 0 10px;
      // }
    }
  }

  .identifybox {
    display: flex;
    justify-content: space-between;
    margin-top: 7px;
  }

  .iconstyle {
    color: #409eff;
  }

  .useinforform {
    margin: -50px auto;
    padding-left: 70px;
    // .usercode {
    //   margin-left: 70px;
    // }
    /deep/.el-input__inner{
      padding-left: 45px;
    }
    .yanzhenginfor {
      margin-top: 10px;
      height: 45px;
      display: flex;
      flex-direction: row;
      .inputpictures {
        width: 276px;
        height: 45px;
      }
      .huanyizhang {
        margin-left: 10px;
        // margin-right:15px;
      }
    }
    .button {
      width: 420px;
      height: 45px;
      font-size: 16px;
      // margin: 32px 0;
      margin-top: 15px;
    }
  }
  .useinforforms,
  .useinforformss {
    margin: -50px auto;
    padding-left: 70px;
    .button {
      width: 420px;
      height: 45px;
      font-size: 16px;
      margin-top: 10px;
    }
    .password {
      width: 420px;
      height: 45px;
    }
  }

  .useinforform,
  .useinforforms,
  .useinforformss {
    width: 560px;
    height: 440px;

    .formtop {
      font-size: 14px;
      margin-bottom: 45px;
      .iconfont {
        font-size: 18px;
        cursor: pointer;
        margin-right: 10px;
      }
    }

    .inputusename {
      width: 420px;
      height: 45px;
      border-radius: 3px;
    }

    .inputpicture {
      width: 276px;
      height: 45px;
    }

    .yanzheng {
      margin-left: 10px;
    }

    .buttons {
      width: 420px;
      height: 45px;
      font-size: 16px;
      margin-top: 15px;
    }
    .loginconfPwd {
      width: 240px;
      height: 40px;
    }
    .email {
      font-size: 14px;
      font-weight: 400;
      color: rgb(3, 103, 204);
      cursor: pointer;
    }
    .getcode {
      padding: 5px 5px;
      width: 134px;
      height: 45px;
      margin-left: 10px;
      border: 1px solid rgb(3, 103, 204);
      border-radius: 3px;
      font-size: 16px;
      font-weight: 400;
      color: rgb(3, 103, 204);
      line-height: 28px;
    }
    .receivecode {
      margin-left: 5px;
      font-family: "Times New Roman", "Microsoft Yahei";
      font-weight: 400;
      color: #a59999;
    }
  }
  .re-register {
    width: 560px;
    height: 440px;
    margin: 50px auto;
    padding-left: 200px;
    .prompt-container {
      display: flex;
      flex-direction: column;
      // align-items: center;
      .sc(32px, #333);
      position: relative;
      top: -90px;
      .icon-container {
        width: 150px;
        height: 150px;
        border: 4px solid rgb(204, 3, 3);
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        i {
          font-size: 80px;
          color: #cc0303;
        }
      }
    }
    .rightname {
      cursor: pointer;
      color: #189bf5;
      border: 1px solid rgb(21, 122, 232);
      border-radius: 5px;
      margin-left: 35px;
      padding: 5px;
      // margin-top:10px;
    }
  }
  .acounttop {
    font-weight: 400;
    color: rgb(0, 0, 0);
    margin-left: -40px;
  }
  .label {
    margin-left: 10px;
  }
}
</style>
<style lang="less">
@import url("../../assets/css/mixin.less");
.forgetPassword {
  .liubian,
  .liubian1 {
    position: relative;
    width: 16px;
    height: 32px;
    margin: 50px auto;
    transform: rotate(90deg);
    text-align: center;
    line-height: 24px;
    color: #fff;
    span {
      position: absolute;
      transform: rotate(-90deg);
      font-family: "Times New Roman", "Microsoft Yahei";
      height: 27px;
      font-size: 18px;
      margin-top: 3px;
      margin-left: -4px;
    }
  }
  .el-step__icon{
    width: 30px;
    height: 30px;
  }
  .el-step__title{
    font-size: 14px;
  }
  .el-step__icon.is-text{
    border:none
  }
  .el-step.is-center .el-step__line {
    left: 62%;
    right: -38%;
 }
  .el-step.is-horizontal .el-step__line {
    top: 13px;
  }
  .el-step__head {
    color: #1890ff;
    &.is-finish,
    &.is-process {
      .el-step__line-inner {
        border-color: #1890ff;
      }
    }
    &.is-finish .el-step__line {
      background-color: #1890ff;
    }
  }
  .el-step__title.is-process {
    color: #262626;
  }
  .el-step__description.is-process {
    color: #262626;
  }
    .el-step__description.is-finish,.el-step__description.is-wait {

    color: #595959;
  }
  .el-step__title.is-finish,.el-step__title.is-wait {
    color: #595959;
  }
  .el-step__head.is-finish {
    .el-step__icon.is-text{
      background: #fff;
      color: #1890ff;
    }

  }
  .el-step__head.is-process {
    .el-step__icon.is-text{
      background: #1890ff;
      color: #fff;
    }

  }
  
  .el-step__head.is-wait {
    .el-step__icon.is-text{
      background: #f2f5f7;
      color: #606266;
    }

  }
  .el-input--suffix .el-input__inner {
    height: 45px;
    padding-left: 47px;
  }
  .el-input__inner {
    height: 45px;
    padding-left: 47px;
  }
  .el-input--prefix .el-input__inner {
    height: 45px;
    padding-left: 47px;
  }

  .hidecode {
    margin-left: 0px;
    .one {
      margin-top: -8px;
    }
    .two {
      margin-top: 3px;
      width: 17px;
      height: 17px;
      background: #b5de70;
      border-radius: 50%;
    }
    i {
      color: #fff;
    }
  }
  .error-hollow {
    display: flex;
    width: 420px;
    .error {
      display: flex;
      justify-content: center;
      font-size: 14px;
      color: #e4393c;
      flex: 1;
      height: 20px;
      font-weight: 400;
      // width: 420px;
      color: rgba(229, 70, 77, 1);
    }
  }
}
</style>